/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react'
import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { sostituisci } from '../../redux/creaEvento'
import DivBottom from '../userNotAuth/components/divBottom'
import EsempiSottotitoli from './components/esempiSottotitoli'
import CollabArtisti from './components/collabArtisti'

let filter = []// array per visualizzare le città in base all'input del client
let filter2 = []// array per visualizzare le regione in base all'input del client

function AddEvento() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const bannerCorrente = searchParams.get('banner')

  const redux = useSelector((state) => state.creaEvento.value)

  const [formData, setFormData] = useState({
    città: redux.città,
    comune: redux.comune,
    indirizzo: redux.indirizzo,
    provincia: redux.provincia,
    dataInizio: redux.dataInizio,
    oraInizio: redux.oraInizio,
    dataFine: redux.dataFine,
    oraFine: redux.oraFine,
    pubblicitàFB: redux.pubblicitàFB,
    regione: redux.regione,
    sottotitolo: redux.sottotitolo,
    titolo: redux.titolo,
    tipologia: redux.tipologia,
  })
  const today = new Date().toISOString().slice(0, 10)
  const [cityFilter, setCityFilter] = useState(null)//città filtrate ad ogni change dell'input 'città'
  const [regioneFilter, setRegioneFilter] = useState(null)//regione filtrate ad ogni change dell'input 'regione'
  const [msg, setMsg] = useState({ msgTitolo: null, msgProvincia: null, msgComune: null, msgIndirizzo: null, msgCittà: null, msgRegione: null })
  const [validateTipologia, setValidateTipologia] = useState(null)
  const [tipo, setTipo] = useState(null)// tipo scelta tra artisti o foodTruck per CollabArtisti
  const città = ['Agrigento', 'Alessandria', 'Ancona', 'Aosta', 'Aquila', 'Arezzo', 'Ascoli Piceno', 'Asti', 'Avellino',
    'Bari', 'Barletta-Andria-Trani', 'Belluno', 'Benevento', 'Bergamo', 'Biella', 'Bologna', 'Bolzano', 'Brescia', 'Brindisi',
    'Cagliari', 'Caltanissetta', 'Campobasso', 'Carbonia', 'Caserta', 'Catania', 'Catanzaro', 'Chieti', 'Como', 'Cosenza', 'Cremona', 'Crotone', 'Cuneo',
    'Enna',
    'Fermo', 'Ferrara', 'Firenze', 'Foggia', 'Forlì e Cesena', 'Frosinone',
    'Genova', 'Gorizia', 'Grosseto',
    'Imperia', 'Isernia',
    'La Spezia', 'Latina', 'Lecce', 'Lecco', 'Livorno', 'Lodi', 'Lucca',
    'Macerata', 'Mantova', 'Massa-Carrara', 'Matera', 'Messina', 'Milano', 'Modena', 'Monza',
    'Napoli', 'Novara', 'Nuoro',
    'Oristano',
    'Padova', 'Palermo', 'Parma', 'Pavia', 'Perugia', 'Pesaro e Urbino', 'Pescara', 'Piacenza', 'Pisa', 'Pistoia', 'Pordenone', 'Potenza', 'Prato',
    'Ragusa', 'Ravenna', 'Reggio Calabria', 'Reggio Emilia', 'Rieti', 'Rimini', 'Roma', 'Rovigo',
    'Salerno', 'Sassari', 'Savona', 'Siena', 'Siracusa', 'Sondrio',
    'Taranto', 'Teramo', 'Terni', 'Torino', 'Trapani', 'Trento', 'Treviso', 'Trieste',
    'Udine',
    'Varese', 'Venezia', 'Verbano', 'Vercelli', 'Verona', 'Vibo Valentia', 'Vicenza', 'Viterbo']
  const regione = ['Abruzzo', 'Basilicata', 'Calabria', 'Campania', 'Emilia Romagna', 'Friuli Venezia Giulia', 'Lazio', 'Liguria', 'Lombardia',
    'Marche', 'Molise', 'Piemonte', 'Puglia', 'Sardegna', 'Sicilia', 'Toscana', 'Trentino Alto Adige', 'Umbria', "Val d'Aosta", 'Veneto'
  ]
  const cittàValue = useRef()//per modificare il value nell'input 'città'
  const regioneValue = useRef()//per modificare il value nell'input 'regione'
  const cityFilterId = useRef()//per display 'block' o 'none' del div delle città selezionabili
  const regioneFilterId = useRef()//per display 'block' o 'none' del div delle regioni selezionabili
  const dataFineId = useRef()
  const dataInizioId = useRef()
  const provincia = useRef()
  const tipologia = useRef()
  const bodyId = useRef(); const collaboratori = useRef()

  function handleChange(e) {
    setMsg({ msgTitolo: null, msgProvincia: null, msgComune: null, msgIndirizzo: null })
    const { name, value, type, checked } = e.target//attributi degli input
    const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value

    if (!(/^([a-zA-Z]{0,})$/.test(inputValue))) {//se il match non è verificato
      const content = document.getElementById(name)
      if (name === 'provincia') { content.value = ''; setMsg({ msgProvincia: 'Carattere non consentito' }); return }
    }

    if (name === 'dataInizio') {
      dataInizioId.current.value = new Date(inputValue).toISOString().slice(0, 10)
      let ingresso = new Date(inputValue).toISOString().slice(0, 10)
      dataFineId.current.min = ingresso//setta il range minimo nel calendario in input dataFine
      if (dataInizioId.current.value > dataFineId.current.value) {
        dataFineId.current.value = ingresso;
        setFormData({ ...formData, dataFine: inputValue, dataInizio: inputValue }); return
      }
    }
    setFormData({ ...formData, [name]: inputValue })//valorizzo il name del nuovo oggetto formData 

    if (name === 'provincia') { provincia.current.value = inputValue.toUpperCase() }
    setValidateTipologia(null)
    tipologia.current.style.border = '1px solid black'
  }
  const cittàCliccata = (elem) => {//porta in input 'cittàValue' la città che clicchiamo dalla lista delle città
    cittàValue.current.value = elem
    setFormData({ ...formData, città: elem })
    setCityFilter(null)
  }
  const dettagliIsOpen = (e, x) => {// per banner da componente a genitore
    setSearchParams({ banner: e }); setTipo(x)
  }
  const regioneCliccata = (elem) => {//porta in input 'cittàValue' la città che clicchiamo dalla lista delle città
    regioneValue.current.value = elem
    setFormData({ ...formData, regione: elem })
    setRegioneFilter(null)
  }
  function handleChangeCittà(e) {
    const { value } = e.target
    filter = []; setCityFilter(null)
    città.forEach((elem, index) => {//filtraggio città da input 'città'
      if (value.toLowerCase() !== '') {
        let result = elem.substring(0, value.length)//result è l'elemento di array 'città' con i numeri di caratteri iniziali uguali all'input 'città'
        if (result.toLowerCase() === value.toLowerCase()) {//match tra input 'città' e array città
          filter.push(elem)//carico l'array con le città trovate        
        }
      }
    })
    if (filter.length > 0) {//se in input 'città' viene trovata una città in array 'citta'
      setCityFilter(filter)
      setMsg({ msgCittà: null })
      cityFilterId.current.style.display = 'block'
    } else {
      cityFilterId.current.style.display = "none"
      setMsg({ msgCittà: 'Città non trovata' })
    }
  }
  function handleChangeRegione(e) {
    const { value } = e.target
    filter2 = []; setCityFilter(null)
    regione.forEach((elem, index) => {//filtraggio regione da input 'regione'
      if (value.toLowerCase() !== '') {
        let result = elem.substring(0, value.length)//result è l'elemento di array 'regione' con i numeri di caratteri iniziali uguali all'input 'regione'
        if (result.toLowerCase() === value.toLowerCase()) {//match tra input 'regione' e array regione
          filter2.push(elem)//carico l'array con le regione trovate        
        }
      }
    })
    if (filter2.length > 0) {//se in input 'regione' viene trovata una regione in array 'citta'
      setRegioneFilter(filter2)
      setMsg({ msgRegione: null })
      regioneFilterId.current.style.display = 'block'
    } else {
      regioneFilterId.current.style.display = "none"
      setMsg({ msgRegione: 'Regione non trovata' })
    }

  }
  function artisti(e, x) {
    setSearchParams({ banner: e })
    setTipo(x)
  }
  function handleSubmit(e) {
    e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
    if (formData.città === null || msg.msgCittà === "Città non trovata" || cittàValue.current.value === '') {
      setMsg({ msgCittà: 'Campo obbligatorio' }); window.scrollTo(0, 100); return
    }
    if (formData.regione === null || msg.msgRegione === "Regione non trovata" || regioneValue.current.value === '') {
      setMsg({ msgRegione: 'Campo obbligatorio' }); window.scrollTo(0, 100); return
    }
    if (formData.tipologia === '') {
      setValidateTipologia('Campo obbligatorio')
      tipologia.current.style.border = '1px solid red'; window.scrollTo(0, 0); return
    }
    dispatch(sostituisci(formData))
    setTimeout(() => {
      navigate('/addEvento2', {
        replace: true,
        state: { fotoFromConfirm: [] }//per gestire le foto se provengo da 'addEvento2'
      })
    }, 200)
  }
  useEffect(() => {
    console.log('bannerCorrente:', bannerCorrente)
    if (bannerCorrente) {//cosa fare quando clicco previous page
      document.body.style.overflow = 'hidden'
    } else { document.body.style.overflow = '' }
  }, [bannerCorrente])

  useEffect(() => {//bodyId è il document.body
    cittàValue.current.addEventListener('change', () => {
      bodyId.current.addEventListener('mouseup', onMouseUp)
      function onMouseUp() {//gestione input 'cittàValue' al click nel body del documento    
        if (formData.città || cityFilterId.current.style.display === "block") {
          cittàValue.current.value = formData.città
          cityFilterId.current.style.display = "none"
          setMsg({ msgCittà: null })
          bodyId.current.removeEventListener('mouseup', onMouseUp)
        }
      }
    })
    regioneValue.current.addEventListener('change', () => {
      bodyId.current.addEventListener('mouseup', onMouseUp)
      function onMouseUp() {//gestione input 'regioneValue' al click nel body del documento    
        if (formData.regione || regioneFilterId.current.style.display === "block") {
          regioneValue.current.value = formData.regione
          regioneFilterId.current.style.display = "none"
          setMsg({ msgRegione: null })
          bodyId.current.removeEventListener('mouseup', onMouseUp)
        }
      }
    })
    const isRefresh = window.performance //intercetto il ricaricamneto della pagina (F5)
      ?.getEntriesByType('navigation')
      ?.[0].type === 'reload'
    if (isRefresh && searchParams.has('banner')) {//rimuovo 'banner' quando ricarico la pagina
      searchParams.delete('banner')
      setSearchParams(searchParams, { replace: true })
    }
    window.scrollTo(0, 0)
  }, [])

  // useEffect(() => { console.log(tipo) }, [tipo])

  return (<>
    {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
      : <NavbarNotAuth />
    }
    <div ref={bodyId} style={{ marginTop: '5rem' }}>
      <div className='container'>
        <div style={{ marginTop: '1em', cursor: 'pointer' }} onClick={() => { navigate('/', { replace: true }) }}>
          <h1>◁</h1>
        </div>
        <h2 style={{ marginTop: '1em' }}>AGGIUNGI EVENTO (1)</h2>

        <form onSubmit={handleSubmit}>
          <div className="col-md-6 mt-5">
            {/* titolo */}
            <label htmlFor='titolo'>Titolo dell'evento *</label>
            <input className="form-control fw-bold" id="titolo"
              name="titolo"
              maxLength={50}
              defaultValue={formData.titolo}
              onChange={handleChange}
              required
              type="text" />
            {msg.msgTitolo && <p style={{ color: 'red', fontSize: 'small' }}><i>{msg.msgTitolo}</i></p>}

            {/* sottotitolo */}
            <div className='mt-4'>
              <label htmlFor='sottotitolo'>Sottotitolo dell'evento<span style={{ fontSize: 'small', marginLeft: '5px' }}>(max 250 caratteri)</span></label>
              <p><i style={{ fontSize: '14px', color: 'maroon' }}>
                descrivi cosa vivrà il partecipante o un motivo per cui l'evento è importante
                <button type='button' onClick={() => { if (!bannerCorrente) setSearchParams({ banner: 'esempiSottotitoli' }) }} style={{
                  backgroundColor: 'maroon', color: 'white', border: 'none', borderRadius: '5px', marginLeft: '5px'
                }}>esempi
                </button>
              </i></p>
              <textarea className="form-control" id="sottotitolo"
                name="sottotitolo"
                rows={5}
                maxLength={250}
                value={formData.sottotitolo}
                onChange={handleChange}
                type="text"
              />
            </div>

            {/* tipologia */}
            <div className="mt-4">
              <label htmlFor='tipologia'>Tipologia evento *</label>
              <select className="form-select mt-3 fw-bold" aria-label="Default select example" style={{ width: 'auto' }}
                name="tipologia" ref={tipologia}
                defaultValue={formData.tipologia}
                onChange={handleChange} >
                <option value=''></option>
                <option value="Auto raduno">Auto raduno</option>
                <option value="Benessere olistico">Benessere olistico</option>
                <option value="Carnevale">Carnevale</option>
                <option value="Concerto">Concerto</option>
                <option value="Concorso">Concorso</option>
                <option value="Cultura">Cultura</option>
                <option value="Enogastronomico">Enogastronomico</option>
                <option value="Evento ludico">Evento ludico</option>
                <option value="Fashion">Fashion</option>
                <option value="Festa del patrono">Festa del patrono</option>
                <option value="Festa a tema">Festa a tema</option>
                <option value="Festival">Festival</option>
                <option value="Fiera">Fiera</option>
                <option value="Halloween">Halloween</option>
                <option value="Luna park">Luna park</option>
                <option value="Meeting">Meeting</option>
                <option value="Mercatino">Mercatino</option>
                <option value="Mercatino natalizio">Mercatino natalizio</option>
                <option value="Moto raduno">Moto raduno</option>
                <option value="Mostra">Mostra</option>
                <option value="Mostra-mercato-fiori">Mostra-mercato-fiori</option>
                <option value="Natale">Natale</option>
                <option value="Notte bianca">Notte bianca</option>
                <option value="Presepe">Presepe</option>
                <option value="Sagra">Sagra</option>
                <option value="Spettacolo di magia">Spettacolo di magia</option>
                <option value="Spettacolo teatrale">Spettacolo teatrale</option>
                <option value="Sportivo">Sportivo</option>
                <option value="Altro">Altro</option>
              </select>
              {validateTipologia && <p style={{ color: 'red' }}><i>{validateTipologia}</i></p>}
            </div>

            {/* regione */}
            <div className="mt-4">
              <label htmlFor='città'>Regione *</label>
              <input
                defaultValue={formData.regione}
                ref={regioneValue}
                className='form-control fw-bold'
                name='regione'
                type='text'
                onChange={handleChangeRegione} />
            </div>

            <div ref={regioneFilterId} style={{
              border: '1px solid black', padding: '5px', margin: '5px', overflow: 'auto', position: 'absolute', width: '20rem',
              display: 'none', backgroundColor: 'whitesmoke'
            }}>
              {regioneFilter &&
                regioneFilter.map((elem, index) => (
                  <span className='filterCity' key={index}>
                    <p style={{ fontFamily: 'sans-serif', cursor: 'pointer' }} onClick={() => { regioneCliccata(elem) }}>{elem}
                    </p>
                  </span>
                ))}
            </div>
            {msg.msgRegione && <p style={{ color: 'red' }}>{msg.msgRegione}</p>}

            {/* città */}
            <div className="mt-4">
              <label htmlFor='città'>Città (provincia) *</label>
              <input
                defaultValue={formData.città}
                ref={cittàValue}
                className='form-control fw-bold'
                name='città'
                type='text'
                onChange={handleChangeCittà} />
            </div>

            <div ref={cityFilterId} style={{
              border: '1px solid black', padding: '5px', margin: '5px', overflow: 'auto', position: 'absolute', width: '20rem',
              display: 'none', backgroundColor: 'whitesmoke'
            }}>
              {cityFilter &&
                cityFilter.map((elem, index) => (
                  <span className='filterCity' key={index}>
                    <p style={{ fontFamily: 'sans-serif', cursor: 'pointer' }} onClick={() => { cittàCliccata(elem) }}>{elem}
                    </p>
                  </span>
                ))}
            </div>
            {msg.msgCittà && <p style={{ color: 'red' }}>{msg.msgCittà}</p>}

            {/*Comune*/}
            <label htmlFor='comune'>Località (comune)*</label>
            <input className="form-control fw-bold"
              defaultValue={formData.comune} id="comune"
              name='comune'
              onChange={handleChange}
              required
              maxLength={30}
              type='text' />
            {msg.msgComune && <p style={{ color: 'red', fontSize: 'small' }}><i>{msg.msgComune}</i></p>}

            {/*Indirizzo*/}
            <label htmlFor='indirizzo'>Indirizzo/Indicazioni *</label>
            <input className="form-control fw-bold"
              defaultValue={formData.indirizzo} id="indirizzo"
              name='indirizzo' required
              onChange={handleChange}
              maxLength={50}
              placeholder='Es. piazza Cavour'
              type='text' />
            {msg.msgIndirizzo && <p style={{ color: 'red', fontSize: 'small' }}><i>{msg.msgIndirizzo}</i></p>}

            {/*Provincia*/}
            <div className='mt-4'> <label htmlFor='form-control fw-bold'>Sigla provincia *</label></div>
            <input className="form-control" ref={provincia} id="provincia"
              defaultValue={formData.provincia}
              name='provincia'
              onChange={handleChange}
              required
              maxLength={3}
              placeholder='Es: RM'
              type='text' />
            {msg.msgProvincia && <p style={{ color: 'red', fontSize: 'small' }}><i>{msg.msgProvincia}</i></p>}

            <div className='mt-4' style={{ display: 'grid', gridTemplateColumns: '.5fr 1fr', gap: '5px', padding: '5px' }} >
              {/*data inizio */}
              <div> <label htmlFor='dataInizio'>Data inizio *</label> </div>
              <div> <input
                ref={dataInizioId}
                defaultValue={formData.dataInizio}
                // min={today}
                name="dataInizio"
                onChange={handleChange}
                required
                type="date" />
              </div>

              {/*ora inizio */}
              <div> <label htmlFor='oraInizio'>Ora inizio</label></div>
              <div> <input
                defaultValue={formData.oraInizio}
                type='time'
                name='oraInizio'
                onChange={handleChange} />
                <span style={{ fontSize: 'small', marginLeft: '1rem', opacity: '.7' }}><i>opzionale</i></span>
              </div>
            </div>
            <hr />
            <div className='mt-4' style={{ display: 'grid', gridTemplateColumns: '.5fr 1fr', gap: '5px', padding: '5px' }} >
              {/*data fine */}
              <div> <label htmlFor='dataFine'>Data fine *</label> </div>
              <div> <input
                ref={dataFineId}
                defaultValue={formData.dataFine}
                min={today}
                name="dataFine"
                required
                onChange={handleChange}
                type="date" />
              </div>
              {/*ora Fine */}
              <div> <label htmlFor='oraFine'>Ora fine</label></div>
              <div> <input
                defaultValue={formData.oraFine}
                type='time'
                name='oraFine'
                onChange={handleChange} />
                <span style={{ fontSize: 'small', marginLeft: '1rem', opacity: '.7' }}><i>opzionale</i></span>
              </div>
            </div><hr />

            {/* Pubblicità in FB */}
            <div className='mt-3' style={{ display: 'grid', gridTemplateColumns: '2rem 1fr', gap: '4px' }} >
              <div><input type='checkbox'
                name='pubblicitàFB'
                checked={formData.pubblicitàFB}
                onChange={handleChange} />
              </div>
              <div><label>Condivisione evento su FaceBook</label></div>

              <div></div>
              <div style={{ fontSize: 'small' }}><i>il tuo evento sarà condiviso su FB e Istangram alla pagina ZonaEventi.</i></div>
            </div><hr />

            {/*fine display grid */}
            <p className='mt-2'><i>* campi obbligatori</i></p>

            <div className='mt-3'>
              {/* Trova collaboratori */}
              <div style={{ width: '100%' }}>
                <button type='button' onClick={() => {
                  if (collaboratori.current.style.display === 'none') { collaboratori.current.style.display = 'block' } else {
                    collaboratori.current.style.display = 'none'; if (bannerCorrente) window.history.back()
                  }
                }}>Trova collaboratori per il tuo evento
                </button>
                <div className='mt-3' style={{ marginLeft: '5px', display: 'none' }} ref={collaboratori}>
                  <button type='button' className='rounded' onClick={() => {
                    if (bannerCorrente !== 'primoArtisti') artisti('primoArtisti', 'artisti')
                  }}>Artisti 🎹
                  </button>
                  <button type='button' className='rounded' style={{ marginLeft: '10px' }} onClick={() => {
                    if (bannerCorrente !== 'primoFoodtruck') artisti('primoArtisti', 'foodTruck')
                  }}>FoodTruck 🍔
                  </button>
                  <button type='button' style={{ border: 'none', marginLeft: '10px' }} onClick={() => {
                    collaboratori.current.style.display = 'none'
                    if (bannerCorrente) window.history.back()
                  }}>❌
                  </button>
                </div>
              </div>
              {/* button avanti indietro */}
              <div className='mt-5'>
                <button type='button' className='btn btn-secondary'
                  onClick={() => {
                    navigate('/', { replace: true })
                  }}>Annulla
                </button>
                <button type='submit' className='btn btn-primary' style={{ marginLeft: '4rem' }}>Avanti</button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <EsempiSottotitoli props={(data) => { setFormData({ ...formData, sottotitolo: data }) }} flag={bannerCorrente} />
      <CollabArtisti props={artisti} tipo={tipo}
        flag={bannerCorrente}
        flag2={bannerCorrente}
        flag3={bannerCorrente}
        dettagliIsOpen={dettagliIsOpen} />
      <DivBottom />
    </div>
  </>
  )
}
export default AddEvento